module.exports = __webpack_public_path__ + "static/media/complete.7b2b2926.svg";